<template>
  <div>
    <v-card class="pl-5 pr-5 pb-5">
      <h1>Select Publication</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />

      <div class="row mt-2">
        <div class="pl-3 pr-8 col">
          <v-text-field
            id="searchLtiPublication"
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col">
          <v-select
            id="orderBy"
            v-model="paging.isASC"
            :items="[{ type: 'Ascending', value: true }, { type: 'Descending', value: false }]"
            label="Order By"
            item-text="type"
            item-value="value"
            return-value="type"
            @change="onFilterChange"
          ></v-select>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <v-select
            id="subject1Filter"
            v-model="paging.subject1Id"
            :items="subjectItems"
            label="Subject 1"
            item-text="SubjectName"
            item-value="id"
            clearable
            @change="onFilterChange"
          ></v-select>
        </div>
        <div class="col">
          <v-select
            id="subject2Filter"
            v-model="paging.subject2Id"
            :items="subjectItems"
            label="Subject 2"
            item-text="SubjectName"
            item-value="id"
            clearable
            @change="onFilterChange"
          ></v-select>
        </div>
        <div class="col">
          <v-select
            id="publisherFilter"
            v-model="paging.publisher"
            :items="publishers"
            label="Publisher"
            item-text="Name"
            item-value="Name"
            clearable
            @change="onFilterChange"
          ></v-select>
        </div>
        <div class="col">
          <v-text-field
            id="publishedYearFilter"
            v-model="paging.publishedYear"
            label="Published Year"
            clearable
            @keyup.enter="onFilterChange"
            @click:clear="onFilterChange"
          ></v-text-field>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th style="width: 48px;"></th>
                  <th style="width: 72px;"></th>
                  <th>Title</th>
                  <th>Edition</th>
                  <th>Publisher</th>
                  <th>Published</th>
                  <!--<th>Collection</th>
                  <th>Subjects</th>-->
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.uuid">
                  <td>
                    <v-checkbox
                      :input-value="item.IsSelected"
                      @change="toggleSelection(item.id)"
                      hide-details
                      class="ma-0 pa-0"
                    ></v-checkbox>
                  </td>
                  <td>
                    <v-img
                      :src="item.ThumbnailUrl || defaultThumbnail"
                      width="48"
                      height="64"
                      contain
                    ></v-img>
                  </td>
                  <td>
                    <div class="font-weight-bold">{{ item.Title }}</div>
                    <div class="caption grey--text">ISBN: {{ item.ISBN }}</div>
                  </td>
                  <td>{{ item.Edition  }}</td>
                  <td>{{ item.Publisher  }}</td>
                  <td>{{ item.PublicationDate }}</td>
                  <!--
                  <td>{{ collectionLabel(item.Collection) }}</td>
                  <td>
                    <v-chip
                      v-for="(subject, idx) in item.Subjects"
                      :key="idx"
                      x-small
                      class="mr-1 mb-1"
                    >{{ subjectLabel(subject) }}</v-chip>
                  </td> -->
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
        <div class="col-12" v-if="!loading && list.length === 0">
          <p class="grey--text text-center mt-5">No publications found.</p>
        </div>
      </div>

      <div class="row align-center">
        <div class="col-12 col-sm-6">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
        <div class="col-12 col-sm-6 text-sm-right">
          <span class="mr-3">{{ selectedIds.length }} selected</span>
          <v-tooltip top > <!--:disabled="!!ref"-->
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on" v-bind="attrs">
                <v-btn
                  id="submitSelection"
                  color="primary"
                  :disabled="selectedIds.length === 0 ||  submitting"  
                  :loading="submitting"
                  @click="onSubmitSelection"
                >Add to Course</v-btn>
              </span>
            </template>
            <span>A live Moodle session is required to submit a selection.</span>
          </v-tooltip>
        </div>
      </div>
    </v-card>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Notification from "@/components/Notification";
import Pagination from "@/components/Pagination";
import * as api from "@/api";

export default {
  name: "LtiPublications",
  components: {
    Notification,
    Pagination,
  },
  created() {
    this.token = this.$route.query.token || "";
    this.ref = this.$route.query.ref || "";

    if (!this.token) {
      this.notify.type = 4;
      this.notify.errors.push(
        "Missing LTI session token. Please relaunch this page from Moodle."
      );
      return;
    }
    this.decodeToken();

    this.organizationId = this.decodeOrganizationId(this.token);
    this.loadSubjects();
    this.loadPublishers();
    this.getListByPagin();
  },
  methods: {
    decodeToken() {
      try {
        const parts = this.token.split(".");
        if (parts.length < 2) throw new Error("Not a valid JWT (expected 3 parts).");
        this.header = JSON.parse(atob(this.padBase64(parts[0])));
        this.payload = JSON.parse(atob(this.padBase64(parts[1])));
        this.flatPayload = this.payload;
        if (this.payload.exp) {
          this.expired = Date.now() / 1000 > this.payload.exp;
        }
        this.organizationId = this.payload.organization.id || 0;

      } catch (e) {
        this.error = "Failed to decode token: " + e.message;
      }
    },

    decodeOrganizationId(token) {
      try {
        const parts = token.split(".");
        if (parts.length < 2) return 0;
        const payload = JSON.parse(atob(this.padBase64(parts[1])));
        return payload.organizationId || 0;
      } catch (e) {
        return 0;
      }
    },
    padBase64(str) {
      return str
        .replace(/-/g, "+")
        .replace(/_/g, "/")
        .padEnd(str.length + ((4 - (str.length % 4)) % 4), "=");
    },
    onNextPage(page) {
      this.paging.page = page;
      this.getListByPagin();
    },
    getListByPagin() {
      this.loading = true;
      this.notify.type = 0;
      this.notify.errors = [];
      this.list = [];
      api
        .postPaginByOrganizationLTI(
          "licenses/lti/publications",
          this.paging,
          this.organizationId,
          this.token
        )
        .then((response) => {
          this.list = response.data.data;
          this.paging.count = response.data.count;

          this.list.forEach((item) => {
             item.IsSelected = false;
          });
        })
        .catch((error) => {
          this.notify.type = 4;
          this.notify.errors.push("Failed to load publications. " + error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    subjectLabel(subject) {
      if (subject == null) return "";
      return typeof subject === "string" ? subject : subject.SubjectName || subject.name || "";
    },
    collectionLabel(collection) {
      if (collection == null) return "-";
      return typeof collection === "string" ? collection : collection.Name || collection.name || "-";
    },
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getListByPagin();
    },
    onFilterChange() {
      this.paging.subject1Id = this.paging.subject1Id || 0;
      this.paging.subject2Id = this.paging.subject2Id || 0;
      this.paging.publisher = this.paging.publisher || "";
      this.paging.publishedYear = this.paging.publishedYear || "";
      this.paging.page = 1;
      this.getListByPagin();
    },
    loadSubjects() {
      api
        .getAllLTI("subject", this.token)
        .then((r) => {
          this.subjectItems = (r.data || []).sort((a, b) =>
            a.SubjectName.localeCompare(b.SubjectName)
          );
        })
        .catch((error) => {
          this.notify.type = 4;
          this.notify.errors.push("Failed to load subjects. " + error);
        });
    },
    loadPublishers() {
      api
        .getAllLTI("publisher", this.token)
        .then((r) => {
          this.publishers = r.data || [];
        })
        .catch((error) => {
          this.notify.type = 4;
          this.notify.errors.push("Failed to load publishers. " + error);
        });
    },
    isSelected(id) {
      return this.selectedIds.includes(id);
    },
    toggleSelection(id) {
      const idx = this.selectedIds.indexOf(id);
      console.log("toggleSelection", id);
      if (idx === -1) {
        this.selectedIds.push(id);
        this.list.forEach((item) => {
          item.IsSelected = this.selectedIds.includes(item.id);
        });
      } else {
        this.selectedIds.splice(idx, 1);
        this.list.forEach((item) => {
          item.IsSelected = this.selectedIds.includes(item.id);
        });
      }
    },
    onSubmitSelection() {
      this.submitting = true;
      this.notify.type = 0;
      this.notify.errors = [];
      api
        .postLTI(
          "lti/deep-link/response",
          { ref: this.ref, publicationIds: this.selectedIds },
          this.token
        )
        .then((response) => {
          this.completeDeepLink(response.data);
        })
        .catch((error) => {
          this.notify.type = 4;
          this.notify.errors.push(this.describeSubmitError(error));
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    describeSubmitError(error) {
      const status = error && error.response && error.response.status;
      if (status === 400) {
        return "Only one publication can be selected — please pick just one.";
      }
      if (status === 404 || status === 401) {
        return "Your session has expired. Please relaunch this page from Moodle.";
      }
      return "Failed to complete selection. " + error;
    },
    completeDeepLink(html) {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const sourceForm = doc.querySelector("form");
      const jwtInput = doc.querySelector('input[name="JWT"]');
      if (!sourceForm || !jwtInput) {
        this.notify.type = 4;
        this.notify.errors.push(
          "Unexpected response from server while completing selection."
        );
        return;
      }
      const form = document.createElement("form");
      form.method = "POST";
      form.action = sourceForm.getAttribute("action");
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "JWT";
      input.value = jwtInput.value;
      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
    },
  },
  data: () => ({
    token: "",
    ref: "",
    organizationId: 0,
    list: [],
    loading: false,
    submitting: false,
    selectedIds: [],
    defaultThumbnail: "https://storage.googleapis.com/prothumia/eBooks/Default_Thumbnail.png",
    notify: {
      type: 0,
      message: "",
      errors: [],
    },
    paging: {
      count: 10,
      page: 1,
      size: 10,
      keyword: "",
      orderColumn: "",
      isASC: true,
      subject1Id: 0,
      subject2Id: 0,
      titie: "",
      publisher: "",
      publishedYear: "",
      skip: null,
    },
    Search: "",
    subjectItems: [],
    publishers: [],
    header: {},
    payload: {},
    flatPayload: {},
    expired: false,
    error: "",
  }),
};
</script>

<style scoped>
.col {
  padding: 8px;
}
.main {
  margin-left: 20px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/LtiPublications.vue